import React, { FC, PropsWithChildren, useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import { FixtureItem } from "@api";

import { TeamsHeader, useTeamsHeaderProps } from "@ui/components";
import { Box, Button, Icon } from "@ui/elements";
import { Stack } from "@ui/layout";

import { MatchDetailsDrawer, ScreenshotButton } from "@components";

type TipBoxProps = PropsWithChildren<{
  fixture: FixtureItem;
  hasTips?: boolean;
}>;

export const TipBox: FC<TipBoxProps> = ({
  fixture,
  children,
  hasTips = true,
}) => {
  const [matchDetailsOpen, setMatchDetailsOpen] = useState(false);
  const teamsHeaderProps = useTeamsHeaderProps(fixture);
  const boxRef = useRef<HTMLDivElement | null>(null);
  const { t } = useTranslation();

  return (
    <Stack direction="column">
      <Box
        ref={boxRef}
        key={`fixture-list-fixture-${fixture.fixture.id}`}
        className="overflow-hidden"
        {...(hasTips && {
          onHeaderClick: () => setMatchDetailsOpen(true),
          footer: (
            <div className="box__footer print-hidden">
              <Stack justify="between">
                <Stack>
                  <ScreenshotButton
                    variant="ghost"
                    filename={`${fixture.teams.home.name} vs ${fixture.teams.away.name}.png`}
                    elementRef={boxRef}
                    width={550}
                    options={{
                      type: "image/png",
                      cacheBust: true,
                    }}
                  >
                    <Icon icon="DownloadSimple" />
                  </ScreenshotButton>
                </Stack>
                <Stack align="center">
                  <Button
                    color="primary"
                    onClick={() => setMatchDetailsOpen(true)}
                  >
                    {t("labels.view-ai-analysis")}
                  </Button>
                </Stack>
              </Stack>
            </div>
          ),
        })}
        header={
          <Stack gap="none">
            <TeamsHeader {...teamsHeaderProps} />
          </Stack>
        }
      >
        <Stack direction="column" gap="md">
          <MatchDetailsDrawer
            isOpen={matchDetailsOpen}
            onClose={() => setMatchDetailsOpen(false)}
            fixture={fixture}
          />
          {children}
        </Stack>
      </Box>
    </Stack>
  );
};
